@if (check === CHECK.DOCUMENT_STATE) {
    @if (
        showOnlyKO ?
        detail?.data?.DOCUMENTS?.state === OPERATION_STATUS.KO :
        true
    ) {
        @for (doc of detail?.data?.DOCUMENTS?.document; track $index) {
            <tec-item
                [classes]="['item--outline']"
                [outline]="true"
                [tagImage]="{icon: 'icon-list-ticks', status: 'simple'}"
                [tagIcon]="getTagIconItem(doc?.state)"
                [title]="'PROCESSES.DETAIL.DOCUMENT_TYPE' | translate"
                [clickeable]="false">
                <tec-list-detail>
                    <span>{{ masterService.hasTranslation('DOCS.' + doc?.type) ? ('DOCS.' + doc?.type | translate) : ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
                </tec-list-detail>
            </tec-item>
        }
    }
}
@if (check === CHECK.DOCUMENTS_EXTERNAL_COMPARE) {
    @for (doc of detail?.data?.DOCUMENTS?.document ?? []; track $index) {
        @if (buildDocumentsCompareTableRowsForDoc(doc).length) {
            <tec-item
                [classes]="['item--outline']"
                [tagImage]="{ icon: 'icon-resize-viewport', status: 'simple' }"
                [tagIcon]="getTagIconItem(doc?.state)"
                [title]="'OPERATIONS.DETAIL.DOCUMENTS_COMPARE_EXTERNAL_MATCH' | translate"
                [clickeable]="false"
            >
                <tec-link (click)="openDocumentsCompare.emit({ doc, event: $event })">
                    {{ 'GENERAL.SHOW_DETAILS' | translate }}
                </tec-link>
                <tec-list-detail>
                    <span>{{ documentCompareTypeLabel(doc) }}</span>
                </tec-list-detail>
            </tec-item>
        }
    }
}
@if (check === CHECK.FINANCIAL_STATE) {
    @if (
        showOnlyKO ?
        detail?.data?.EVALUATION?.state === OPERATION_STATUS.KO :
        true
    ) {
        <tec-item
            [classes]="['item--outline']"
            [outline]="true"
            [tagImage]="{icon: 'icon-list-ticks', status: 'simple'}"
            [tagIcon]="getTagIconItem(detail?.data?.EVALUATION?.state)"
            [title]="detail?.data?.EVALUATION?.type === CONNECTION_TYPE.BANK_SCORING ? ('PROCESSES.DETAIL.CONNECTION_TYPE' | translate) : ('PROCESSES.DETAIL.DOCUMENT_TYPE' | translate)"
            [clickeable]="false">
            <tec-list-detail>
                <span>{{ masterService.hasTranslation('FINANCIAL_EVALUATION.' + detail?.data?.EVALUATION?.type) ? ('FINANCIAL_EVALUATION.' + detail?.data?.EVALUATION?.type | translate) : ('GENERAL.NOT_AVAILABLE' | translate) }}</span>
            </tec-list-detail>
        </tec-item>
    }
}
@if (check === CHECK.ATTORNEY_POWERS_STATE) {
    @if (
        showOnlyKO ?
        detail?.data?.ATTORNEY_POWERS?.state === OPERATION_STATUS.KO :
        true
    ) {
        <tec-item
            [classes]="['item--outline']"
            [outline]="true"
            [tagImage]="{icon: 'icon-shield-check', status: 'simple'}"
            [tagIcon]="getTagIconItem(detail?.data?.ATTORNEY_POWERS?.state)"
            [title]="'PROCESSES.DETAIL.DOCUMENT_TYPE' | translate"
            [clickeable]="false">
            <tec-list-detail>
                <span>{{
                    masterService.hasTranslation('FINANCIAL_EVALUATION.' + detail?.data?.ATTORNEY_POWERS?.type)
                        ? ('FINANCIAL_EVALUATION.' + detail?.data?.ATTORNEY_POWERS?.type | translate)
                        : ('WORKFLOWS.FORM.OPERATIONS.ATTORNEY_POWERS' | translate)
                }}</span>
            </tec-list-detail>
        </tec-item>
    }
}
@if (check === CHECK.EVALUATION_MATCH_DATA) {
    @if (
        showOnlyKO ?
        detail?.data?.EVALUATION?.state === OPERATION_STATUS.KO :
        true
    ) {
        <tec-item
            [classes]="['item--outline']"
            [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
            [tagIcon]="getTagIconItem(detail?.data?.EVALUATION?.state)"
            [title]="detail?.data?.EVALUATION?.type === CONNECTION_TYPE.BANK_SCORING
                ? (detail?.data?.EVALUATION?.evaluation === EVALUATION_TYPE.SCORING
                    ? ('PROCESSES.DETAIL.FINANCIAL_EVALUATION_OPTION' | translate)
                    : ('PROCESSES.DETAIL.VERIFY_IDENTITY' | translate))
                : (masterService.hasTranslation('FINANCIAL_EVALUATION.' + detail?.data?.EVALUATION?.type)
                    ? ('FINANCIAL_EVALUATION.' + detail?.data?.EVALUATION?.type | translate)
                    : ('PROCESSES.DETAIL.FINANCIAL_EVALUATION_OPTION' | translate))"
            [clickeable]="false">
            @if (detail?.data?.EVALUATION?.evaluation === EVALUATION_TYPE.MATCH_DATA) {
            <tec-list-detail>
                <span>{{ 'PROCESSES.DETAIL.EVALUATION_MATCH_DATA' | translate }}</span>
            </tec-list-detail>
            }
        </tec-item>
    }
}
@if (check === CHECK.FORM_MATCH_DATA) {
    @if (shouldShowFormMatchData()) {
        <tec-item
            [classes]="['item--outline']"
            [outline]="true"
            [tagImage]="{icon: 'icon-resize-viewport', status:'simple'}"
            [tagIcon]="getTagIconItem(formMatchCheckStatus)"
            [title]="formMatchDataLabelKey | translate"
            [clickeable]="false">
            @if (formMatchCompareRows.length) {
                <tec-link (click)="openFormMatchModal.emit()">
                    {{ 'GENERAL.SHOW_DETAILS' | translate }}
                </tec-link>
            }
        </tec-item>
    }
}
